export class EditorNode {
  constructor(type) {
    this.type = type;
  }

  /**
   * Render the node to a DOM element
   * @param {Object} data - Node data
   * @param {Object} context - Context (callbacks, etc.)
   * @returns {HTMLElement}
   */
  render(_data, _context) {
    throw new Error('render must be implemented');
  }

  /**
   * Serialize the node to string format
   * @param {HTMLElement} element
   * @returns {string}
   */
  serialize(_element) {
    throw new Error('serialize must be implemented');
  }

  /**
   * Check if the element matches this node type
   * @param {HTMLElement} element
   * @returns {boolean}
   */
  match(element) {
    return element.getAttribute('data-type') === this.type;
  }

  /**
   * Update an existing node element with new data
   * @param {HTMLElement} element - The DOM element to update
   * @param {Object} data - New data
   * @param {Object} context - Context (callbacks, etc.)
   * @returns {void}
   */
  update(_element, _data, _context) {
    // Optional implementation
  }
}
